export const home = {
  no_login: 'No login',
  login_out: 'Sign out',
  home_create: 'Create',
  login_out_title: 'Are you sure you want to sign out?',
  login_tittle: 'Launch App',
  email_login_tittle: 'Sign in your shakker account',
  login_discord: 'Discord',
  login_google: 'Google',
  login_email: 'Or, sign up with Email',
  login_email_introducer: 'username@shakker.ai',
  login_continue: 'NEXT',
  login_agreement_text: 'By continuing you agree to the {{termsOfUse}} and {{privacyPolicy}}',
  login_agreement_terms_of_use: 'Terms of Use',
  login_agreement_privacy_policy: 'Privacy Policy',
  login_checkemail_text1: 'Check your Email on computer',
  login_settings: 'Settings',
  login_checkemail_text2:
    'We have sent a login link to your Email Address. If you don’t get the email, please check your spam folder.',
  home_try: 'Try It',
  invitation_email_name: 'Your Email',
  invitation_problem_name: 'Please also tell us the following:',
  invitation_problem_placeholder: 'Why are you interested in Shakker.Ai?',
  invitation_continue: 'Request Access',
  invitation_code_lable: 'Already have an invite code?',
  invitation_code_placeholder: 'Enter code here',
  invitation_err_code: 'Invalid code?',
  invitation_email_introducer: 'We will send invite code to your email',
  invitation_status1_title: 'Request Received!',
  invitation_status2_title: 'We have sent you an invitation code by email:',
  invitation_status1_guide: 'Stay tuned for updates on our',
  invitation_status1_explain: 'You will receive an invite with the next batch of invites at the following email:',
  home_save: 'Save',
  invitation_email_err_text1: 'Please fill in your email',
  invitation_email_err_text2: 'Not in line with specifications, please try again',
  invitation_status2_guide1: 'Didn’t get the email?Please check in your spam folder Or ',
  invitation_status2_guide2: 'to send code again',
  res_success_title: 'Operation successful',
  res_fail_title: 'Operation failed, please try again',
  alert_cancel: 'Cancel',
  alert_confirm: 'Confirm',
  user_name: 'User Name',
  user_name_placeholder: 'Please enter your username',
  user_name_description: 'Please enter 1-15 characters,consisting of letters, numbers, or underscores "_"',
  user_change_avatar: 'Uploading',
  foot_aiCookiePolicy: 'Cookie Policy',
  foot_aiUserAgreement: 'Terms of Use',
  foot_aiPrivacyPolicy: 'Privacy Policy',
  foot_aiReturnPolicy: 'Return Policy',
  avatar_infraction: 'Avatar image does not meet guidelines, please re-upload.',
  survey_vocation_title: 'Which Best Describes You?',
  survey_vocation_other: 'Please describe',
  survey_continue: 'Continue',
  survey_Interest_title: 'What are you interested in?',
  survey_Interest_choice: 'Pick {{n}} More',
  survey_start_shakker: 'Start Shakker',
  foot_aiContactUs: 'contact us',
};
